import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
export const fields = ["snap_six_months"];

const validate = (values, props) => {
  const errors = {};
  if (!values.snap_six_months) {
    errors.snap_six_months = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection07 = props => {
  const {
    allText,
    fields: { snap_six_months },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section07 };
  const progress = 6;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-question-margin">
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={snap_six_months} />
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection07.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection07);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection07.js